import { useState } from 'react';

export default () => {
  const [userId, setUserId] = useState<string>("");


  const updateUserId = (id: string) => {
    setUserId(id);
  };

  return { userId, updateUserId };
};
